import React from "react";
import {styled} from "@reside/ui";
import {UserPermissionEnum} from "../../../../utils/types/user";
import {RoleNameEnum} from "../../../../utils/types/common";

import {PermissionsMacroCheckbox} from "../permissions-macro-checkbox";
import {GeneralTypes, CheckboxesTypes, OtherTypes} from "./permissionTypes";
import {AdminRoles} from "../../../../atoms/admin-roles";
import {
  QuicksightDashboardDeferredSaveHandlers,
  QuicksightDashboardsMacroCheckbox,
} from "../quicksight-dashboards-macro-checkbox";

type Props = Readonly<{
  userId: string;
  activePermissions: ReadonlyArray<UserPermissionEnum>;
  deferQuicksightSave?: boolean;
  isPermissionPending?: (permission: UserPermissionEnum) => boolean;
  onDeferredQuicksightSaveHandlersChange?: (
    handlers: QuicksightDashboardDeferredSaveHandlers | null,
  ) => void;
  onSetPermission: (permissions: ReadonlyArray<UserPermissionEnum>) => void;
}>;

export const PermissionManagementForm = ({
  userId,
  activePermissions,
  deferQuicksightSave,
  isPermissionPending,
  onDeferredQuicksightSaveHandlersChange,
  onSetPermission,
}: Props) => (
  <PermissionsFormGrid>
    <ShortCategoriesColumn>
      <PermissionsMacroCheckbox
        label="General"
        permissions={GeneralTypes}
        activePermissions={activePermissions}
        isPermissionPending={isPermissionPending}
        onSetPermission={onSetPermission}
      />
      <PermissionsMacroCheckbox
        label="Checkboxes"
        permissions={CheckboxesTypes}
        activePermissions={activePermissions}
        isPermissionPending={isPermissionPending}
        onSetPermission={onSetPermission}
      />
      <AdminRoles roles={[RoleNameEnum.RESIDE_ADMIN]}>
        <PermissionsMacroCheckbox
          label="Other"
          permissions={OtherTypes}
          activePermissions={activePermissions}
          isPermissionPending={isPermissionPending}
          onSetPermission={onSetPermission}
        />
      </AdminRoles>
    </ShortCategoriesColumn>
    <QuicksightColumn>
      <QuicksightDashboardsMacroCheckbox
        userId={userId}
        activePermissions={activePermissions}
        deferSave={deferQuicksightSave}
        onDeferredSaveHandlersChange={onDeferredQuicksightSaveHandlersChange}
        onSetPermission={onSetPermission}
      />
    </QuicksightColumn>
  </PermissionsFormGrid>
);

const PermissionsFormGrid = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 24px;
`;

const ShortCategoriesColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
`;

const QuicksightColumn = styled.div`
  flex: 1;
  min-width: 0;
`;
